import { request } from '@/util/http'

export const getList = (wxUserId) => {
  return request({
    url: '/health/userPcGroupChat/list',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

export const getUserBodyInfo = (wxUserId) => {
  return request({
    url: '/health/userPcGroupChat/getUserBodyInfo',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/userPcGroupChat/submit',
    method: 'post',
    data: row
  })
}

export const getListByPcGroupChatId = (wxUserId, pcGroupChatId) => {
  return request({
    url: '/health/userPcGroupChatDataInfo/listByPcGroupChatId',
    method: 'get',
    params: {
      wxUserId,
      pcGroupChatId
    }
  })
}

export const submitPcGroupChatDataInfo = (row) => {
  return request({
    url: '/health/userPcGroupChatDataInfo/submit',
    method: 'post',
    data: row
  })
}

export const getBaiLianUploadFileId = (row) => {
  return request({
    url: '/aLiYun/getBaiLianUploadFileId',
    method: 'post',
    data: row
  })
}

export const getFileStatusByFileId = (FileId) => {
  return request({
    url: '/aLiYun/getFileStatusByFileId',
    method: 'get',
    params: {
      FileId
    }
  })
}

